import React from "react";

function EmptyPage() {
    return (
        <div style={{ margin: '10px'}}>
            <p>죄송합니다.</p>
            <p>요청하신 페이지를 찾을 수 없습니다.</p>
        </div>
    );
}

export default EmptyPage;